import { createReducer } from '@reduxjs/toolkit'
import { preloadedRootState } from '../../rootState'
import { markFirstVisit, markFirstVisitReducer } from './markFirstVisitReducer'
import { setUser, setUserReducer } from './setUserReducer'
import { setUserStatus, setUserStatusReducer } from './setUserStatusReducer'
import { setUserLoaded, setUserLoadedReducer } from './setUserLoadedReducer'

const userReducers = createReducer(preloadedRootState.user, builder => {
  builder.addCase(setUser.type, setUserReducer)
  builder.addCase(setUserStatus.type, setUserStatusReducer)
  builder.addCase(markFirstVisit.type, markFirstVisitReducer)
  builder.addCase(setUserLoaded.type, setUserLoadedReducer)
})

export default userReducers
